import { render } from "./QuizStep4.vue?vue&type=template&id=6629cd89"
import script from "./QuizStep4.vue?vue&type=script&lang=js"
export * from "./QuizStep4.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__